import React from 'react';

import { Spacing, Title } from '@vkontakte/vkui';

import styles from './index.module.css';
import { FamousPersonsProps } from './types';
import { FamousPerson } from '../../../components/FamousPerson';

export const FamousPersons: React.FC<FamousPersonsProps> = ({ temperamentData }) => {
  return (
    <div>
      <Title level="2" className={styles.famousPeopleTitle}>
          Знаменитые представители
      </Title>
      <Spacing size={16}/>
      <div className={styles.famousPeopleContainer}>
        {temperamentData.famousPersons.map(({ image, name, subtitle, smallImage }: any) => {
          return (
            <div className={styles.famousPeopleCellContainer}>
              <FamousPerson
                image={image}
                smallImage={smallImage}
                name={name}
                subtitle={subtitle}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
